import { render, staticRenderFns } from "./AftersaleDetail.vue?vue&type=template&id=a11eb214&scoped=true"
import script from "./AftersaleDetail.vue?vue&type=script&lang=js"
export * from "./AftersaleDetail.vue?vue&type=script&lang=js"
import style0 from "./AftersaleDetail.vue?vue&type=style&index=0&id=a11eb214&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11eb214",
  null
  
)

export default component.exports